<template>
  <v-text-field
    class="minHeightInput"
    :class="importClass"
    :value="inputValue"
    :solo="solo"
    :suffix="suffix"
    :placeholder="placeholder"
    :label="label"
    :outlined="outlined"
    :autofocus="autofocus"
    dense
    :clearable="clearable"
    :readonly="readonly"
    :disabled="disabled"
    :counter="counter"
    :rules="rules"
    :hide-details="hideDetails"
    :rounded="rounded"


    @input="$emit('input',$event)"
    @keypress="$emit('keypress',$event)">
    <template v-slot:append>
      <slot/>
    </template>
  </v-text-field>

</template>

<script>
//clear-icon="mdi-close"
import {thousandComma} from "../../plugins/helper";

export default {
  name: "CustomTextField",
  props: {
    value: {
      type: String | Number,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: false
    },
    outlined: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    suffix: {
      type: String,
    },
    counter: {
      type: Number,
    },
    importClass: {
      type: String,
    },
    clearable: {
      type: Boolean,
      default: false
    },
    comma: {
      type: Boolean,
      default: false
    },
    solo: {
      type: Boolean,
      default: false
    },
  },
  data: () => {
    return {
      thousandComma,
    };
  },
  computed: {
    inputValue: {
      get() {

        let val = this.value;
        if (this.comma) {
          if (typeof val == 'string') {
            val = this.value.replace(/,/g, "")
          }
          return this.thousandComma(val)
        } else {
          return this.value
          // if (typeof val == 'string') {
          //   return this.value.trim()
          // }else{
          //   return this.value
          // }


        }
      },
      set(value) {
      },
    },

  },
}
</script>

<style scoped>
.v-application--is-rtl .v-text-field__suffix {
  padding-right: 15px;
  border-right: 1px solid #cacaca;
}
</style>
